export const TYPE_CLASS_LIST = [
	/****** 101 Electrical******/
  { code: 101, type: "Electrical", classification: "Switchgears, Switches & Separators" },
  { code: 102, type: "Electrical", classification: "High tension" },
  { code: 103, type: "Electrical", classification: "Motors & Generators" },
  { code: 104, type: "Electrical", classification: "Transformers" },
  { code: 105, type: "Electrical", classification: "Capacitors" },
  { code: 106, type: "Electrical", classification: "Resistors & Electronic components" },
  { code: 107, type: "Electrical", classification: "Power supply & converter" },
  { code: 108, type: "Electrical", classification: "Fuses" },
  { code: 109, type: "Electrical", classification: "Relays & Contactors" },
  { code: 110, type: "Electrical", classification: "Control units" },
  { code: 111, type: "Electrical", classification: "Cables, Connectors & Busbars" },
  { code: 112, type: "Electrical", classification: "Sensors" },
  { code: 113, type: "Electrical", classification: "Lights" },
  { code: 114, type: "Electrical", classification: "Other electrical" },
	/****** 201 Mechanical******/
  {code: 201,type: "Mechanical", classification: "Bearings",},
  { code: 202, type: "Mechanical", classification: "Brackets, Hinges" },
  { code: 203, type: "Mechanical", classification: "Brakes" },
  { code: 204, type: "Mechanical", classification: "Bushings" },
  { code: 205, type: "Mechanical", classification: "Couplings" },
  {code: 206,type: "Mechanical",classification: "Covers"},
  {code: 207,type: "Mechanical",classification: "Dampers"},
  { code: 208, type: "Mechanical", classification: "Die, Molding" },
  { code: 209, type: "Mechanical", classification: "Engineering elements" },
  { code: 210, type: "Mechanical", classification: "Gears & Accessories" },
  { code: 211,type: "Mechanical",classification: "Gears, Yaw TRACE"},
  { code: 212, type: "Mechanical", classification: "Sealings & O-rings" },
  { code: 213, type: "Mechanical", classification: "Shafts, other" },
	/****** 301 Consumables & Fastening******/
  { code: 301, type: "Consumables & Fastening", classification: "Paints" },
  { code: 302, type: "Consumables & Fastening", classification: "Cleaning materials" },
  { code: 303, type: "Consumables & Fastening", classification: "Gloves" },
  { code: 304, type: "Consumables & Fastening", classification: "Stationary" },
  { code: 305, type: "Consumables & Fastening", classification: "Steel Wires, Chains and accessory" },
  { code: 306, type: "Consumables & Fastening", classification: "Bolt set" },
  { code: 307, type: "Consumables & Fastening", classification: "Fasteners, nuts" },
  { code: 308, type: "Consumables & Fastening", classification: "Washers & Shims" },
  { code: 309, type: "Consumables & Fastening", classification: "Filters hydraulic" },
  { code: 310, type: "Consumables & Fastening", classification: "Caps and plugs" },
  { code: 311, type: "Consumables & Fastening", classification: "Consumption materials, Packing materials" },
  { code: 312, type: "Consumables & Fastening", classification: "Adhesives & Sealants" },
/****** 401 Hydraulics & Cooling******/
  { code: 401, type: "Hydraulics & Cooling", classification: "Hydraulic fittings & hoses" },
  {code: 402,type: "Hydraulics & Cooling",classification: "Pump, Radiators",},
  { code: 403, type: "Hydraulics & Cooling", classification: "Hydraulic cylinders, Pitch TRACE" },
  { code: 404, type: "Hydraulics & Cooling", classification: "Ventilation / Climatisation" },
  {code: 405,type: "Hydraulics & Cooling",classification: "Heat Exchangers", },
  { code: 406, type: "Hydraulics & Cooling", classification: "Hydraulic tanks" },
  {code: 407,type: "Hydraulics & Cooling",classification: "Manifold, Hydraulics"},
  {code: 408, type: "Hydraulics & Cooling",classification: "Hydraulic accumulators",},
  { code: 409, type: "Hydraulics & Cooling",classification: "Hydraulic valves, proportional TRACE"},
	/****** 501 Rotor, Tower & Panel******/
  { code: 501, type: "Rotor, Tower & Panel", classification: "Blades" },
  {code: 502,type: "Rotor, Tower & Panel",classification: "Blade accessories",},
  {code: 503,type: "Rotor, Tower & Panel",classification: "Tower Options and Accessories",},
  {code: 504,type: "Rotor, Tower & Panel",classification: "Hub / Nose cone complete TRACE",},
/****** 601 Lubricants******/	
  { code: 601, type: "Lubricants", classification: "Oil & Grease" },
	/****** 701 -Safety******/	
  {code: 701,type: "Safety",classification: "Personal protective equipments",},
  { code: 702, type: "Safety", classification: "Mats & Extinguishers" },
	/****** 801- Tools******/	
  {code: 801,type: "Tools",classification: "Electrical",},
  { code: 802, type: "Tools", classification: "Mechanical" },
];
